import { Epic } from 'redux-observable';
import { from } from 'rxjs';
import { switchMap, withLatestFrom, filter } from 'rxjs/operators';
import { ReportsViewServiceImpl } from '../services';
import {
  reportsViewFetchDashboardFailed,
  reportsViewFetchDashboardRequest,
  reportsViewFetchDashboardSuccess,
} from '../reportsViewSlice';
import { RootState } from '../../../../store';

type IN = ReturnType<typeof reportsViewFetchDashboardRequest>;
type OUT =
  | ReturnType<typeof reportsViewFetchDashboardSuccess>
  | ReturnType<typeof reportsViewFetchDashboardFailed>;

export const ReportsViewOnFetchDataEpic: Epic<IN | OUT, OUT, RootState> = (
  action$,
  state$,
) =>
  action$.pipe(
    filter(reportsViewFetchDashboardRequest.match),
    withLatestFrom(state$),
    switchMap(([, state]) => {
      return from(
        ReportsViewServiceImpl.getReportsData()
          .then((data) => reportsViewFetchDashboardSuccess(data))
          .catch((error) => {
            console.error(error);
            return reportsViewFetchDashboardFailed({
              msg: 'Failed to fetch data',
            });
          }),
      );
    }),
  );
